export enum eTimeCard {
  /**
   * 月卡
   */
  MONTH = 0,
  /**
   * 周卡
   */
  WEEK = 1,
}
